import React, { useState, FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Icon, Layout, Menu, Spin } from 'antd';
import { SiderProps } from 'antd/lib/layout';

import { getRoute, RoutePathName } from '../routes';
import { MainReducerState } from '../store/reducers';
import { getDocumentsStructureState, DocumentsState } from '../store/actions/documents';
import { isAdmin } from '../utils';
import { getUser, CheckLoginStatusState } from '../store/actions/auth';
import SubMenu from 'antd/lib/menu/SubMenu';
import { list as listSections } from '../store/actions/sections';

interface MenuProps {
    structureState: DocumentsState['structure'];
    user: CheckLoginStatusState['user'];
    getSections: typeof listSections.trigger;
}
const MainMenu: FC<MenuProps> = ({
    structureState,
    user,
    getSections,
}) => {

    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const onCollapse: SiderProps['onCollapse'] = (value) => {
        setCollapsed(value);
    };

    useEffect(() => {
       getSections({});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Layout.Sider
            collapsible
            collapsed={collapsed}
            onCollapse={onCollapse}
        >
            <Spin spinning={structureState.loading}>
                <Menu
                    mode="inline"
                    defaultSelectedKeys={[location.pathname]}
                    defaultOpenKeys={['sub1']}
                >
                    <Menu.Item key={'/documents'}>
                        <Link to={'/documents'}>
                            <Icon type="home" /><span>Accueil</span>
                        </Link>
                    </Menu.Item>
                    {structureState.data && structureState.data.map((section: any) => (
                        <SubMenu
                            key={getRoute(RoutePathName.documents, { section: section.id })}
                            title={(
                                <Link to={getRoute(RoutePathName.documents, { section: section.id })}>
                                    <Icon type={section.picto} /><span>{collapsed === false && section.short}</span>
                                </Link>
                            )}
                        >
                            {Object.values(section.years).map((year: any) => (
                                <Menu.Item key={getRoute(RoutePathName.documents, { section: section.id, year })}>
                                    <Link to={getRoute(RoutePathName.documents, { section: section.id, year })}>
                                        <span>{year}</span>
                                    </Link>
                                </Menu.Item>
                            ))}
                            {section.children && section.children.map((subSection: any) => (
                                <SubMenu
                                    key={getRoute(RoutePathName.documents, { section: subSection.id })}
                                    title={(
                                        <Link to={getRoute(RoutePathName.documents, { section: subSection.id })}>
                                            <Icon type={subSection.picto} />
                                            <span>{collapsed === false && subSection.short}</span>
                                        </Link>
                                    )}
                                >
                                    {Object.values(subSection.years).map((year: any) => (
                                        <Menu.Item
                                            key={getRoute(RoutePathName.documents, { section: subSection.id, year })}
                                        >
                                            <Link
                                                to={getRoute(RoutePathName.documents, { section: subSection.id, year })}
                                            >
                                                <span>{year}</span>
                                            </Link>
                                        </Menu.Item>
                                    ))}
                                </SubMenu>
                            ))}
                        </SubMenu>
                    ))}
                    {isAdmin(user) && (
                        <Menu.Item key={getRoute(RoutePathName.users)}>
                            <Link to={getRoute(RoutePathName.users)}>
                                <Icon type="user" />
                                <span>Utilisateurs</span>
                            </Link>
                        </Menu.Item>
                    )}
                    {isAdmin(user) && (
                        <Menu.Item key={getRoute(RoutePathName.sections)}>
                            <Link to={getRoute(RoutePathName.sections)}>
                                <Icon type="setting" />
                                <span>Rubriques</span>
                            </Link>
                        </Menu.Item>
                    )}
                </Menu>
            </Spin>
        </Layout.Sider>
    );
};

const mapStateToProps = (state: MainReducerState) => ({
    structureState: getDocumentsStructureState(state),
    user: getUser(state),
});

export default connect(
    mapStateToProps,
    {
        getSections: listSections.trigger,
    },
)(MainMenu);
